import { useAuthStore } from '@/shared/model';

/**
 * 사용자가 특정 team의 LEADER인지 client-side derive.
 *
 * AuthUser는 단일 teamId + teamRole 보유 (사용자 = 단일 팀 소속) → 비교만으로 충분.
 * 별도 endpoint 없이 user context에서 derive.
 *
 * 사용처: Override trigger (CheckpointDistributionPanel headerAction) ·
 * InlineHint (task value override affordance) — LEADER 식별 필요한 모든 곳.
 *
 * [Source: docs/archive/quest-reward-distribution-v0.5-pr1.6c-plan.md §1 #4]
 */
export function useIsLeaderOf(teamId: string | undefined): boolean {
  return useAuthStore(
    (s) => teamId !== undefined && s.user?.teamId === teamId && s.user.teamRole === 'LEADER'
  );
}
